<template>
  <v-container
    id="work-management-view"
    fluid
    tag="section"
  >
    <cumulus-edit-dialog
      ref="editWorker"
      v-model="dialogEditWorker"
      icon="$users"
      :max-width="700"
      title="workers"
      :loading="loading"
      @save="saveWorkers"
      @escape="closeDialogEditWorkers"
    >
      <template v-slot:editform>
        <edit-work-management-workers
          :workers="editedItem.workers"
        />
      </template>
    </cumulus-edit-dialog>

    <material-card
      icon="$work_management"
      icon-small
      color="accent"
      :title="page_title"
    >
      <v-card-title>
        <v-btn
          v-if="editor"
          v-shortkey.once="['f2']"
          color="primary"
          class="mb-2"
          @shortkey="edit()"
          @click="edit()"
        >
          {{ $t('new_item',{ item: $t('work') }) }}
        </v-btn>
        <work-management-user-informations />
        <v-spacer />
        <v-row class="ma-0">
          <v-switch
            v-model="show_closed"
            class="mx-2"
            :label="$t('show_closed')"
          />
          <v-text-field
            v-model="search"
            append-icon="$search"
            class="ml-auto"
            hide-details
            :label="$t('search_records')"
            single-line
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="computed_headers"
          :items="items"
          :loading="loading"
          :loading-text="$t('loading')"
          :options.sync="options"
          :server-items-length="total"
          :footer-props="footerProps"
          :item-class="row_classes"
          show-expand
          :single-expand="singleExpand"
          :expanded.sync="expanded"
        >
          <template #item.leader_id="{item}">
            {{ item.leader ? item.leader.name : '' }}
            <tooltip-btn
              v-if="item.leader && !item.success_date && item.leader.id === profile.user_id"
              color="red"
              icon="$close"
              tooltip="tooltip_unset_leader"
              @click="clickClearLeader(item)"
            />
          </template>
          <template #item.actions="{item}">
            <tooltip-btn
              v-if="item.leader === null"
              color="black"
              icon="$undertake"
              tooltip="tooltip_set_leader"
              @click="clickLeader(item)"
            />
            <tooltip-btn
              v-if="item.leader ? (item.leader.id === profile.user_id && !item.success_date) : false"
              color="orange"
              icon="$users"
              tooltip="tooltip_edit_workers"
              @click="showDialogEditWorkers(item)"
            />
            <tooltip-btn
              v-if="!item.success_date && checker"
              color="primary"
              icon="$success"
              tooltip="tooltip_lock_work"
              @click="clickCloseWork(item)"
            >
              <v-icon v-text="'$success'" />
            </tooltip-btn>
            <tooltip-btn
              v-else-if="item.success_date && checker"
              color="primary"
              icon="$lock_open"
              tooltip="tooltip_unlock_work"
              @click="clickOpenWork(item)"
            />
            <tooltip-btn
              v-for="(action, i) in actions"
              :key="i"
              :show="!action.disable"
              :color="action.color"
              :icon="action.icon"
              :tooltip="action.tooltip"
              @click="action.func(item)"
            />
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="ma-3 pa-6">
              <div>
                <v-row>
                  <v-col cols="12" md="6" class="text-h4 font-weight-medium text-right">
                    {{ $t('fields.comment') }}:
                  </v-col>
                  <v-col> {{ item.comment }} </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="text-h4 font-weight-medium text-right">
                    {{ $t('fields.leader') }}:
                  </v-col>
                  <v-col> {{ item.leader ? item.leader.name : '' }} </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="text-h4 font-weight-medium text-right">
                    {{ $t('fields.deadline_date') }}:
                  </v-col>
                  <v-col> {{ item.deadline_date }} </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="text-h4 font-weight-medium text-right">
                    {{ $t('fields.success_date') }}:
                  </v-col>
                  <v-col> {{ item.success_date }} </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6" class="text-h4 font-weight-medium text-right">
                    {{ $t('fields.working_hours') }}:
                  </v-col>
                  <v-col> {{ item.working_hours }} </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" class="text-h4 font-weight-medium text-right">
                    {{ $t('fields.workers') }}:
                  </v-col>
                  <v-col>
                    <p
                      v-for="(worker,i) in item.workers"
                      :key="i"
                    >
                      {{ worker.name }}: {{ worker.hour.hour }} {{ $t('fields.hour') }}
                    </p>
                    <p
                      v-if="!item.success_date"
                    >
                      <v-btn
                        v-if="item.workers.filter(w => w.id === profile.user_id).length === 0"
                        @click="clickAddWorker(item)"
                      >
                        Jelentkezem
                      </v-btn>
                      <v-btn
                        v-else
                        @click="clickRemoveWorker(item)"
                      >
                        Lemondom
                      </v-btn>
                    </p>
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
  // Utilities
  import { get, call, sync } from 'vuex-pathify'
  import EditWorkManagementWorkers from '@/layouts/default/edit/WorkManagementWorkers'
  import WorkManagementUserInformations from '@/layouts/default/infos/WorkManagementUserInfo'

  export default {
    name: 'WorkManagement',
    components: {
      WorkManagementUserInformations,
      EditWorkManagementWorkers,
    },
    data () {
      return {
        expanded: [],
        singleExpand: true,
        items: [],
        // table
        footerProps: {
          itemsPerPageOptions: [10, 20, 25, 50, 100],
        },
        total: 0,
        timer: null,
        show_closed: false,
        dialogEditWorker: false,
        editedItem: {},
      }
    },
    computed: {
      loading: get('app/loading'),
      profile: get('auth/profile'),
      options: sync('workManagement/options'),
      search: sync('workManagement/search'),
      table_headers () {
        return [
          {
            text: this.$t('fields.work_name'),
            align: 'start',
            sortable: true,
            value: 'work_name',
          },
          {
            hide_small: true,
            text: this.$t('fields.comment'),
            sortable: false,
            value: 'comment',
          },
          {
            hide_small: true,
            text: this.$t('fields.deadline_date'),
            sortable: true,
            value: 'deadline_date',
            width: 150,
          },
          {
            hide_small: true,
            text: this.$t('fields.leader'),
            sortable: true,
            value: 'leader_id',
            width: 170,
          },
          {
            text: this.$t('actions'),
            value: 'actions',
            sortable: false,
            align: 'right',
            width: 150,
          },
        ]
      },
      actions () {
        return [
          { color: 'edit', icon: '$edit', tooltip: 'tooltip_edit', func: this.edit, disable: !this.editor },
          // { name: 'workers', color: 'orange', icon: '$users', func: this.editWorkers },
        ]
      },
      page_title () { return this.$t('work_management') },
      editor () { return this.profile.can['work-management-edit'] },
      checker () { return this.profile.can['work-management-checker'] },
      computed_headers () {
        return this.table_headers.filter(h => h.hide_small !== this.$vuetify.breakpoint.mdAndDown)
      },
    },
    watch: {
      search: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.load()
          }, 800)
        },
        deep: true,
      },
      options: {
        handler () {
          this.load()
        },
        deep: true,
      },
      show_closed: {
        handler () {
          this.load()
        },
        deep: true,
      },
    },
    mounted () {
      // console.log(this.profile)
      // this.load()
    },
    methods: {
      getList: call('workManagement/search'),
      setLeader: call('workManagement/setLeader'),
      clearLeader: call('workManagement/clearLeader'),
      setWorkers: call('workManagement/setWorkers'),
      addWorker: call('workManagement/addWorker'),
      removeWorker: call('workManagement/removeWorker'),
      closeWork: call('workManagement/closeWork'),
      openWork: call('workManagement/openWork'),

      async load () {
        try {
          const { sortBy, sortDesc, page, itemsPerPage } = this.options
          await this.getList({
            page: page,
            per_page: itemsPerPage,
            sort: {
              field: sortBy,
              order: sortDesc,
            },
            search: this.search,
            show_closed: this.show_closed,
          }).then(response => {
            this.items = response.data
            this.total = response.total
          }).catch(e => {
            console.log(e)
          })
        } catch (e) {
        }
      },
      edit (item) {
        this.$router.push(`/work-management/${item ? item.id : -1}`).catch(() => {})
      },

      async clickLeader (item) {
        await this.setLeader({
          id: item.id,
        }).then(response => {
          this.load()
          console.log('Vállalom!')
        }).catch(e => {
          console.log(e)
        })
      },
      async clickClearLeader (item) {
        await this.clearLeader({
          id: item.id,
        }).then(response => {
          this.load()
          console.log('Lemondom!')
        }).catch(e => {
          console.log(e)
        })
      },
      async clickAddWorker (item) {
        await this.addWorker({
          id: item.id,
        }).then(response => {
          this.load()
          console.log('Jelentkezem!')
        }).catch(e => {
          console.log(e)
        })
      },
      async clickRemoveWorker (item) {
        await this.removeWorker({
          id: item.id,
        }).then(response => {
          this.load()
          console.log('Lemondom!')
        }).catch(e => {
          console.log(e)
        })
      },

      async clickCloseWork (item) {
        await this.closeWork({
          id: item.id,
        }).then(response => {
          this.load()
        }).catch(e => {
          console.log(e)
        })
      },
      async clickOpenWork (item) {
        await this.openWork({
          id: item.id,
        }).then(response => {
          this.load()
        }).catch(e => {
          console.log(e)
        })
      },

      showDialogEditWorkers (item) {
        console.log(item)
        this.editedItem = Object.assign({}, item)
        this.dialogEditWorker = true
      },
      closeDialogEditWorkers () {
        console.log('close dialog')
        this.dialogEditWorker = false
        this.load()
      },
      async saveWorkers () {
        await this.setWorkers(this.editedItem).then(response => {
          this.editedItem.workers = response
          this.closeDialogEditWorkers()
        })
      },

      row_classes (item) {
        if (item.success_date !== null) {
          return 'green lighten-5'
        } else if (item.leader !== null) {
          if (item.leader.id === this.profile.user_id) {
            return 'blue lighten-4'
          } else {
            return 'blue lighten-5'
          }
        }
      },
    },
  }
</script>
